import {environment} from "../../environments/environment";

const urldocument = environment.urlApi + "v1/files/file/";

export const Documents = {
  Document1: urldocument + "MAP_Fiche_synthese_Section2.pdf",
  Document2: urldocument + "MAP_Memo_Types_pansements.pdf",
  Document3: urldocument + "L&R_poster_plaie_pansement.pdf",
  Document4: urldocument + "MAP_Fiche_synthese_Section3.pdf",
  Document5: urldocument + "MAP_Fiche_synthese-Section5.pdf",
  Document6: urldocument + "L&R_memo_pansements_techniques.pdf",
  DocumentTitre: urldocument + "MAP_Diplome.pdf",
}

export const DocumentsIds = {
  Document1: "MAP_Fiche_synthese_Section2",
  Document2: "MAP_Memo_Types_pansements",
  Document3: "L&R_poster_plaie_pansement",
  Document4: "MAP_Fiche_synthese_Section3",
  Document5: "MAP_Fiche_synthese-Section5",
  Document6: "L&R_memo_pansements_techniques",
  DocumentTitre: "MAP_Diplome",
}
